import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { ICcyLookupService } from "../ICcyLookupService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class CcyLookupService
  extends BaseLookupService<string, CubiqTS.CurrencyImpl>
  implements ICcyLookupService
{
  constructor() {
    super(CubiqTS.CurrencyImpl);
  }

  getCcy(code: string): CubiqTS.CurrencyImpl {
    let ccy: CubiqTS.CurrencyImpl = this.getItem(code);

    return ccy;
  }

  getItemKey(item: CubiqTS.CurrencyImpl): string {
    return item.id;
  }
}
